// extracted by mini-css-extract-plugin
export default {"buttons":"Activity_buttons__KkTKg"};